import styled from "@emotion/styled";
import Tooltip from "src/components/Tooltip";
import { PRIMARY_BLACK } from "src/constants/colors";

const Container = styled.div<{ borderType: "solid" | "dashed" | "none" }>`
  border-bottom: 1px ${(props) => props.borderType} rgba(228, 231, 236, 1);
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
`;

const IconWrapper = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  & > svg {
    height: 16px;
    width: 16px;
  }
`;

const KeyLabel = styled.div`
  font-size: 12px;
`;

const ValueLabel = styled.div<{ allowOverflow: boolean }>`
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  overflow: ${({ allowOverflow }) => (allowOverflow ? "visible" : "hidden")};
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const shouldDisableToolTip = (text: unknown) => {
  if (!text || typeof text !== "string") {
    return true;
  }
  const maxCharCount = 35;

  return text.length < maxCharCount;
};

export const DetailRow = ({
  icon,
  keyText,
  value,
  borderType = "solid",
  allowOverflow = false,
}: {
  icon?: React.ReactNode;
  keyText: string;
  value: string | React.ReactNode;
  borderType?: "solid" | "dashed" | "none";
  allowOverflow?: boolean;
}) => (
  <Container borderType={borderType}>
    <IconWrapper>
      {icon}
      <KeyLabel>{keyText}</KeyLabel>
    </IconWrapper>
    {allowOverflow ? (
      <ValueLabel allowOverflow={allowOverflow}>{value}</ValueLabel>
    ) : (
      <Tooltip
        tooltipContent={value}
        disableTooltip={shouldDisableToolTip(value)}
      >
        <ValueLabel allowOverflow={allowOverflow}>{value}</ValueLabel>
      </Tooltip>
    )}
  </Container>
);
